import MainPage from "./pages/MainPage";

function App() {
  return (
    <div className="container-fluid">
      <MainPage />
    </div>
  );
}

export default App;
